import axiosInstance from "../Interceptors/ResponseInterceptor";

export const uploadAttachment = async (formData, project_code) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(
        `/api/attachment/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "project-code": project_code,
          },
        }
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in uploadAttachment:", error);
      reject(error);
    }
  });
};

export const tagUploadedAttachment = async (body, project_code) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(
        `/api/attachment/tag-attachments`,
        body,
        {
          headers: {
            "project-code": project_code,
          },
        }
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in tagUploadedAttachment:", error);
      reject(error);
    }
  });
};

export const deleteAttachment = async (fileName, project_code) => {
  console.log("fileName", fileName);
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.delete(
        `/api/attachment/delete/${fileName}`,
        {
          headers: {
            "project-code": project_code,
          },
        }
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in uploadAttachment:", error);
      reject(error);
    }
  });
};

export const getAttachmentsByProjectCode = async (project_code) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `api/attachment/projectcode/${project_code}`,
        {
          headers: {
            "project-code": project_code,
          },
        }
      );
      resolve(response.data);
    } catch (error) {
      console.log("error in getting attachments by project code", error);
      reject(error);
    }
  });
};

export const getAllAttachmentCategory = async (partner) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`api/attachment-category`, {
        params: { partner },
      });
      resolve(response.data);
    } catch (error) {
      console.log("error in getting attachments by project code", error);
      reject(error);
    }
  });
};

export const downloadAttachment = async (projectCode, uniqueFileName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/attachment/download/${projectCode}/${uniqueFileName}`,
        {
          responseType: "blob",
        }
      );
      resolve(response);
    } catch (error) {
      console.log("error in getting attachments by project code", error);
      reject(error);
    }
  });
};

export const getAllStatusesAndRemarks = async (partner) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`api/site-activities-modal`, {
        params: { partner },
      });
      resolve(response.data);
    } catch (error) {
      console.log("error in getting all status", error);
      reject(error);
    }
  });
};

export const getSpecificRemarkCategoryForActivity = async (
  activity_order,
  activity_name,
  partner_id
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `api/activity-remarks/category/${activity_order}`,
        {
          params: { partner_id, activity_name },
        }
      );
      resolve(response.data);
    } catch (error) {
      console.log("error in getting activity's remarks", error);
      reject(error);
    }
  });
};
